import { memo, useCallback } from 'react'
import { ButtonBase } from '@mui/material'
import { useTranslations } from '@/core/translation'
import { GoogleColoredLogo } from '@/assets'
import { Box } from '@/components/Layout'
import { StarRating, Text } from '@/components/Data'
import { googleReviewStyle as styles } from './GoogleReview.style'

const REVIEW_RATING = 5

const GOOGLE_REVIEW_URL =
  'https://www.google.com/search?q=Bookseats&rlz=1C1UEAD_enCA1152CA1152&oq=bookseats+&gs_lcrp=EgZjaHJvbWUqBggAEEUYOzIGCAAQRRg7MgYIARBFGDwyBggCEEUYPDIGCAMQRRhBMgYIBBBFGDwyBggFEEUYPDIGCAYQRRhBMgYIBxBFGEHSAQgxNzk0ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8#lrd=0x882b35e55c445491:0xc265924ce659ccea,1'

function GoogleReview() {
  const t = useTranslations('banner')

  const onRedirect = useCallback(() => {
    window.open(GOOGLE_REVIEW_URL, '_blank')
  }, [])

  return (
    <ButtonBase sx={styles.wrapper} onClick={onRedirect}>
      <Box sx={styles.logo} component={GoogleColoredLogo} />
      <Text sx={styles.text}>{t('reviewAverage', { average: 4.9 })}</Text>
      <StarRating rating={REVIEW_RATING} />
    </ButtonBase>
  )
}

export default memo(GoogleReview)
